export default function FinalCTA() {
  return (
    <section data-cascade className="relative w-full py-32 md:py-48 bg-offwhite paper-texture overflow-hidden">
      {/* Minimal organic glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[450px] h-[450px] md:w-[650px] md:h-[650px] rounded-full bg-rose-light/6 blur-[150px]" />
      </div>

      <div className="relative max-w-[600px] mx-auto px-6 md:px-12 text-center flex flex-col items-center gap-10">
        {/* Small elegant photo */}
        <div data-cascade-image className="w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden border border-gold-matte/10">
          <img
            src="https://storage.helloreaddy.io/project_files/7ae9a526-920c-4103-99ac-b845e125a623/72aa91bf-157e-4c62-8b55-dd22a7e0fe50_compressed_Imagem-1-gerada-16.webp"
            alt="Dra. Nathália Posso"
            className="w-full h-full object-cover"
          />
        </div>

        <h2 data-cascade-title className="font-heading text-3xl md:text-4xl lg:text-5xl text-graphite font-light leading-[1.15]">
          Cuidar da sua saúde começa com{' '}
          <span className="italic">uma conversa</span>.
        </h2>

        <p data-cascade-text className="font-body text-sm md:text-base text-graphite/45 font-light leading-relaxed max-w-sm">
          Agende sua consulta e dê o primeiro passo para uma vida com mais saúde, equilíbrio e bem-estar.
        </p>

        <a
          href="https://api.whatsapp.com/send/?phone=5585984293412&text=Ol%C3%A1%21+Gostaria+de+informa%C3%A7%C3%B5es+sobre+procedimentos+e+consultas+com+a+Dra+Nathalia&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-breathe btn-shimmer font-body text-xs font-semibold text-white bg-graphite hover:bg-graphite/85 hover:scale-[1.03] px-12 py-5 tracking-[0.12em] uppercase transition-all duration-500 whitespace-nowrap mt-2"
        >
          Agendar Consulta
        </a>

        <div className="flex items-center gap-4 pt-1">
          <span className="font-body text-[10px] text-secondary-500 tracking-[0.2em]">CRM 14200</span>
          <span className="text-secondary-300">·</span>
          <span className="font-body text-[10px] text-secondary-500 tracking-[0.2em]">RQE 8571</span>
        </div>
      </div>
    </section>
  );
}